import React from 'react';
import { get, post, put, del } from '../../Utility/Http';
import { getRefereeApiGet} from './RefereeModel';
import Config from '../../Utility/Config';

export const getRefereeListApi = async () => {
    console.log(process.env.EXTENDED_URL);
    const response = await get(`${Config.EXTENDED_URL}admin/referee/list`, null);
    return getRefereeApiGet(response);
};


